import axios from "axios";
import ErrorParser from '../../services/error.parser';

const UnitsService = {
  units: async function () {
    const requestData = {
      method: "get",
      url: "/api/units"
    };
    try {
      const response = await axios(requestData);
      return JSON.parse(response.data);
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
};

export default UnitsService;

